// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCifSJ6RklxvqjYNFWWXx9aMZ8aAsYupzg",
  authDomain: "joujo-safaris.firebaseapp.com",
  projectId: "joujo-safaris",
  storageBucket: "joujo-safaris.firebasestorage.app",
  messagingSenderId: "587763793233",
  appId: "1:587763793233:web:e769f2ba4b7cf2b6742770",
  measurementId: "G-STW3TTRF7Y"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db, collection, addDoc };
